<template>
  <div>
    <a-card>
      <div style="margin-bottom:50px;">

        <div style="margin-bottom:10px">
          <span style="font-size:18px;font-weight:700;color:black;padding-right:20px">我的钱包</span>
        <!-- <a-icon type="question-circle" style="color:#ff7171;"/>
        <sapn style="color:#6c9af7;padding-left:5px;">电子收款凭证</sapn>-->
        </div>
        <div style="margin-bottom:10px">账户余额（元）</div>
        <div style="margin-bottom:15px">
          <span style="padding-right:50px;font-size:18px;font-weight:700;color:black;">{{ totalBalance }}</span>
          <router-link to="/wallet/recharge">
            <a-button type="danger" ghost>充值</a-button>
          </router-link>
        </div>
        <span>钱包余额仅用于消费，不支持提现</span>

      </div>

      <div class="table-page-search-wrapper" style="padding-bottom:20px">
        <a-row :gutter="16">
          <a-col :md="12" :sm="24" style="display:flex">
            <span style="line-height:32px">发起时间：</span>
            <a-range-picker @change="onChangeTime">
              <a-icon slot="suffixIcon" type="smile" />
            </a-range-picker>
          </a-col>
          <a-col :md="10" :sm="12">
            <span>订单编号：</span>
            <a-input v-model="orderNo" style="width: 180px" />
          </a-col>
          <a-button type="primary" @click="query">查询</a-button>
        </a-row>
      </div>
      <a-spin :spinning="spinning">
        <a-table
          :pagination="pagination"
          size="default"
          ref="table"
          :data-source="data6"
          :columns="columns5"
          bordered
          showHeader="false"
          @change="changePage" />
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
// import store from '@/store'  amount-enterprise
export default {
  name: 'WalletLIst',
  components: {},
  computed: {
    ...mapGetters(['nickname', 'avatar'])
  },
  data () {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` // 分页中显示总的数据
      },
      data6: [],
      columns5: [
        {
          title: '交易时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '对应订单号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '流水号',
          dataIndex: 'tradeNo',
          align: 'center'
        },
        {
          title: '业务类型',
          dataIndex: 'operType',
          align: 'center'
        },
        {
          title: '金额',
          dataIndex: 'changeAmount',
          align: 'center'
        },
        {
          title: '钱包余额（元）',
          dataIndex: 'balance',
          align: 'center'
        }
      ],
      totalBalance: '', // 钱包余额
      enterpriseId: this.$store.getters.enterpriseId, // 企业ID
      StartTime: '', // 开始时间
      EndTime: '', // 结束时间
      orderNo: '', // 订单编号
      spinning: false // 加载
    }
  },
  created () {
    this.information() // 获取余额信息
    this.information4()
  },
  methods: {
    // 账户信息
    information () {
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${this.enterpriseId}`,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
      })
    },

    // 查询
    query () {
      this.pagination.current = 1
      this.information4()
    },
    // 账单
    async information4 () {
      this.spinning = true
      try {
        const res = await this.$axios({
          method: 'get',
          url: '/api/finance/detailed/list',
          params: {
            enterpriseId: this.enterpriseId,
            StartTime: this.StartTime,
            EndTime: this.EndTime,
            orderNo: this.orderNo
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
        this.data6 = res.data.rows
        this.spinning = false
      } catch (err) {
        console.log(err)
      }
    },
    onChangeTime (date, dateString) {
      this.StartTime = dateString[0]
      this.EndTime = dateString[1]
    },
    changePage (e) {
      const { current, pageSize } = e
      this.pagination.current = current
      this.pagination.pageSize = pageSize
    }
  },
  watch: {
    $route (to, from) {
      this.information4()
      this.information()
    }
  }
}
</script>
<style scoped></style>
